module.exports = __webpack_public_path__ + "img/jifenrenwu_yaoqingkaika.212755cc.png";